export default {
    NEW: 'New',
    USED: 'Used',
    COMMERCIAL: 'Commercial',
};
